import React from 'react'

import AddSubscriptionForm from '../../modules/Subscription/components/AddSubscriptionForm'
export default function AddSubscriptionPage() {
  return <AddSubscriptionForm />
}
